<template>
  <div class="f2e-h5-ordonnance_toC_doctor">
    <!-- <div :class="renderCls()" v-if="!preview">
      <div class="top">
        <img :src="renderImg" v-if="renderImg" alt="" />
        <span class="status_header_text">{{ renderText }}</span>
      </div>
      <div class="prescriptionRemark" v-if="REJECT || UNAUDIT">
        <span>{{ prescriptionRemark }}</span>
      </div>
    </div> -->

    <div class="box">
      <div class="box-head">
        <div class="title">{{ hospitalName }}智云互联网医院 用药建议</div>
        <!-- <div class="ordonnance-type">普通药品处方</div> -->
      </div>
      <div class="box-patient">
        <!-- <div class="box-patient-row">
          <span class="label">处方单号：</span>
          <span class="content">{{ id }}</span>
        </div> -->
        <div class="box-patient-row">
          <div class="item">
            <span class="label">姓名：</span>
            <span class="content">{{ username }}</span>
          </div>
          <div class="item">
            <span class="label">性别：</span>
            <span class="content">{{ gender }}</span>
          </div>
          <div class="item">
            <span class="label">年龄：</span>
            <span class="content">{{ age }}</span>
          </div>
        </div>
        <div class="box-patient-row">
          <!-- <div class="item">
            <span class="label">科别：</span>
            <span class="content">{{ doctorDeptName }}</span>
          </div> -->
          <div>
            <span class="label">日期：</span>
            <span class="content">{{ reviewTime }}</span>
          </div>
        </div>
        <!-- <div class="box-patient-row">
          <div>
            <span class="label">诊断：</span>
            <span class="content">{{ illness }}</span>
          </div>
        </div> -->
      </div>
      <div class="box-druge">
        <template v-if="prescriptionType == 2">
          <div class="zy-goods">
            <h4 class="title">用药建议</h4>
            <section class="flex-container">
              <!-- 中药颗粒/饮片样式不同 -->
              <div class="flex-item" :class="['tcm', drugType === 2 ? 'tcm-granules' : '']" v-for="(item, index) in detailModelList" :key="index">
                <div class="main">
                  <span class="tcm-name">
                    {{ item.drugName }}
                    <b v-if="item.fryingMethod && ordonnanceData.isShowCount" class="decoction">({{ item.fryingMethod }})</b>
                  </span>

                  <span v-if="ordonnanceData.isShowCount" class="tcm-unit">{{ item.num }}{{ item.unit }}</span>
                </div>
                <div class="spec" v-if="item.spec && drugType === 2 && item.unit != 'g' && ordonnanceData.isShowCount">{{ item.spec }}</div>
              </div>
            </section>
            <span v-if="!ordonnanceData.isShowCount" class="hide-count-hint">*支付完成后可查看完整药方信息</span>
          </div>
          <section class="tcm-usage">
            <h4 class="title">用法用量</h4>
            <p>
              共{{ ordonnanceData.totalDose }}剂，每日{{ ordonnanceData.dosagePerDay }}剂，每剂分{{
                ordonnanceData.medicineFrequency
              }}次使用
            </p>
            <p>用药方式：{{ ordonnanceData.medicineMethod }}</p>
            <p>用药时间：{{ ordonnanceData.medicineTime }}</p>
          </section>
        </template>
        <template v-else>
          <!-- <div class="rp">
            <img
              class="rp_img"
              src="https://91jkys-static.oss-cn-hangzhou.aliyuncs.com/third_files/GuoYao/202010/16/cb62bc2926685aee68252a0ca64f7ed5.png"
              alt="rp"
            />
          </div> -->
          <div class="box-drug-row" v-for="(item, index) in detailModelList" :key="index">
            <div class="title">{{ renderDrug_detail(item) }}</div>
            <div class="usage">用法：{{ usage(item) }}</div>
          </div>
          <!-- <div class="access" v-if="id && badge">
            <img :src="badge" alt="" />
          </div> -->
        </template>
      </div>
      <div class="box-hint" v-if="ordonnanceData.medicalAdvice">
        <div class="title">注意事项</div>
        <div class="content">{{ ordonnanceData.medicalAdvice }}</div>
      </div>
      <div class="box-doctor"></div>
    </div>
  </div>
</template>
<script>
import { baseFormat } from '@zyf2e/utils';
export default {
  props: ['ordonnanceData', 'showTitle', 'preview'],
  computed: {
    totalAmount() {
      const { totalAmount } = this.ordonnanceData;
      if (!totalAmount && totalAmount != 0) {
        return '';
      }
      return (totalAmount / 100).toFixed(2);
    },
    hospitalName() {
      const { internetHospitalName } = this.ordonnanceData;
      if (!internetHospitalName) {
        return '';
      }
      return internetHospitalName;
    },
    badge() {
      return this.ordonnanceData.internetHospitalSignUrl;
    },
    reviewTime() {
      const { prescriptionReauditTime } = this.ordonnanceData;
      if (prescriptionReauditTime) {
        return baseFormat(prescriptionReauditTime, 'YYYY年MM月DD日');
      }
      return '';
    },
    EXPIRED() {
      //已失效
      if (this.ordonnanceData.prescriptionAuditStatus == 'EXPIRED' || this.ordonnanceData.status == `EXPIRED`) {
        return true;
      }
      return false;
    },
    REJECT() {
      //药师驳回
      if (this.ordonnanceData.prescriptionAuditStatus == 'REJECT' || this.ordonnanceData.status == `REJECT`) {
        return true;
      }
      return false;
    },
    UNAUDIT() {
      //待审核
      if (this.ordonnanceData.prescriptionAuditStatus == 'UNAUDIT') {
        return true;
      }
      return false;
    },
    AUDIT() {
      //处方完成
      if (this.ordonnanceData.prescriptionAuditStatus == 'AUDIT') {
        return true;
      }
      return false;
    },
    prescriptionRemark() {
      //驳回理由
      const { prescriptionRemark } = this.ordonnanceData;
      return prescriptionRemark;
    },
    renderText() {
      const { ordonnanceData } = this;
      const { prescriptionAuditStatus } = ordonnanceData;
      if (this.UNAUDIT) return `待审核`;

      if (this.REJECT) return `已驳回`;

      if (this.EXPIRED) return `已过期`;

      if (prescriptionAuditStatus === `REAUDIT`) return `待复核`;
      if (prescriptionAuditStatus === `AUDIT`) return `审核成功`;
    },
    renderImg() {
      //渲染图片
      const wait = `https://static.91jkys.com/third_files/GuoYao/202004/15/49204f6e22404cd498ea06f008b9b3b5.png`;
      const rej = `https://static.91jkys.com/third_files/GuoYao/202004/15/ffb25fe90af24664b2074b17ddbd5fb8.png`;
      const inv = `https://static.91jkys.com/third_files/GuoYao/202004/15/9e216866b8a74af1adaa287fa82c85f7.png`;
      if (this.UNAUDIT) return wait;

      if (this.REJECT) return rej;

      if (this.EXPIRED) return inv;
    },

    prescriptionReauditorName() {
      const { prescriptionReauditorName } = this.ordonnanceData;
      return prescriptionReauditorName;
    },
    prescriptionAuditorSignUrl() {
      const { prescriptionAuditorSignUrl } = this.ordonnanceData;
      if (!prescriptionAuditorSignUrl) {
        return '';
      }
      return `${this.getImgServer()}${prescriptionAuditorSignUrl}`;
    },
    prescriptionReauditorSignUrl() {
      const { prescriptionReauditorSignUrl } = this.ordonnanceData;
      if (!prescriptionReauditorSignUrl) {
        return '';
      }
      return `${this.getImgServer()}${prescriptionReauditorSignUrl}`;
    },
    doctorSignUrl() {
      //医师签名
      const { doctorSignUrl } = this.ordonnanceData;
      if (!doctorSignUrl) {
        return '';
      }
      return `${this.getImgServer()}${doctorSignUrl}`;
    },
    symptom() {
      //主诉
      return this.ordonnanceData.symptom;
    },

    dispatcherSignature() {
      //核对发药
      return `${this.getImgServer()}${this.ordonnanceData.dispatcherSignature}`;
    },
    dispenserSignature() {
      //调配
      return `${this.getImgServer()}${this.ordonnanceData.dispatcherSignature}`;
    },
    prescriptionAuditorName() {
      //审核医师名称
      return this.ordonnanceData.prescriptionAuditorName;
    },
    doctorName() {
      //医师名称
      return this.ordonnanceData.doctorName;
    },
    createTime() {
      //开具时间
      return baseFormat(this.ordonnanceData.orderTime, 'YYYY年MM月DD日');
    },
    detailModelList() {
      // 处方列表
      return this.ordonnanceData.detailModelList;
    },
    illness() {
      //疾病诊断
      return this.ordonnanceData.illness;
    },
    userBaseInfoModel() {
      //患者信息
      return this.ordonnanceData.userBaseInfoModel;
    },
    gender() {
      //性别
      try {
        if (this.userBaseInfoModel.gender == '1') {
          return '男';
        }
        if (this.userBaseInfoModel.gender == '2') {
          return '女';
        }
      } catch (error) {
        return `缺少用户信息`;
      }
    },
    age() {
      try {
        return this.userBaseInfoModel.age + '岁';
      } catch (error) {
        return `缺少用户信息`;
      }
    },
    doctorDeptName() {
      //医生科室
      return this.ordonnanceData.doctorDeptName || '';
      // return `内科-${this.ordonnanceData.doctorDeptName}` || '未填写';
    },
    id() {
      //处方号
      return this.ordonnanceData.id;
    },

    districtFullPath() {
      //患者所在城市
      return this.ordonnanceData.region;
    },
    username() {
      //患者姓名
      try {
        return this.userBaseInfoModel.name;
      } catch (error) {
        return `缺少用户信息`;
      }
    },
    doctorPrescriptionType() {
      return this.ordonnanceData.doctorPrescriptionType;
    },
    complianceDoctorName() {
      return this.ordonnanceData.complianceName;
    },
    complianceDoctorSignUrl() {
      const { complianceDoctorSignUrl } = this.ordonnanceData;
      if (!complianceDoctorSignUrl) {
        return '';
      }
      return `${this.getImgServer()}${complianceDoctorSignUrl}`;
    },
    prescriptionType() {
      return this.ordonnanceData.prescriptionType;
    },
    drugType() {
      return this.ordonnanceData.drugType;
    }
  },
  methods: {
    renderCls() {
      const { ordonnanceData } = this;
      const { prescriptionAuditStatus } = ordonnanceData;
      console.log(this.UNAUDIT);

      const cls = {
        status_header: true,
        REAUDIT: prescriptionAuditStatus === `REAUDIT`,
        AUDIT: this.AUDIT,
        UNAUDIT: this.UNAUDIT,
        REJECT: this.REJECT,
        EXPIRED: this.EXPIRED
      };
      return cls;
    },

    getImgServer() {
      var host = window.location.host;
      if (host.indexOf(this.PROD_HOST) > -1) {
        return 'https://static-image.91jkys.com';
      } else if (host.indexOf(this.PRE_HOST) > -1) {
        return 'https://static-image.pre.91jkys.com';
      } else {
        return 'http://static.qa.91jkys.com';
      }
    },

    renderDrug_detail(item) {
      //渲染处方详情
      const { name, drugName, chemicalName, spec, num, unit } = item;
      const showName = name || drugName || chemicalName || '';
      let specs = spec || '';
      let handnum = this.valid(num);
      let units = unit || '';
      return `${showName} ${specs} 【${handnum} ${units}】`;
    },
    valid(num) {
      //处理数量
      var temp = parseInt(num, 10);
      if (isNaN(temp) || temp < 0) {
        return '';
      } else {
        return num;
      }
    },
    usage(item) {
      //处理用法用量
      var usage = item.usage || '';
      var perAmount =
        item.perNum && item.perUnit && item.perUnit != '无'
          ? item.perNum + item.perUnit + '/次'
          : item.perNum && (!item.perUnit || item.perUnit == '无')
          ? item.perNum + '/次'
          : '';
      var usageFrequencyName = item.usageFrequencyName || '';
      var dose = item.dose ? '用药' + item.dose + '天' : '';
      // return usage + ' ' + perAmount + ' ' + usageFrequencyName + ' ' + dose;
      return usage + ' ' + perAmount + ' ' + usageFrequencyName;
    }
  }
};
</script>
<style lang="less" scoped>
.f2e-h5-ordonnance_toC_doctor {
  background: #fff;

  .status_header {
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 18px 12px;
    .top {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .UNAUDIT,
  .REAUDIT,
  .AUDIT {
    color: #fff;
    font-size: 18px;
    background: #32c795;
    img {
      display: block;
      width: 20px;
      margin-right: 4px;
    }
  }

  .REJECT {
    color: #fff;
    font-size: 18px;
    background: #f56b56;
    img {
      display: block;
      width: 20px;
      margin-right: 4px;
    }
    .prescriptionRemark {
      margin-top: 10px;
      color: #fff;
      font-size: 14px;
    }
  }
  .EXPIRED {
    background: #cccccc;
    color: #fff;
    font-size: 18px;
    img {
      display: block;
      width: 20px;
      margin-right: 4px;
    }
  }
  .prescriptionRemark {
    margin-top: 10px;
    color: #fff;
    font-size: 14px;
  }

  .box {
    padding: 0 16px;
    &-head {
      display: flex;
      justify-content: center;
      position: relative;
      margin-bottom: 36px;
      padding-top: 36px;
      .ordonnance-type {
        position: absolute;
        right: -4px;
        bottom: 2px;
        // max-width: 50px;
        width: 44px;
        height: 32px;
        font-size: 12px;
        color: #333333;
        border: 2px solid rgb(66, 64, 64);
        // white-space: 1px;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
      .title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #262626;
        line-height: 18px;
      }
    }
    &-patient-row,
    &-druge-row,
    &-doctor-row {
      display: flex;
      margin-top: 8px;
    }
    &-patient {
      font-size: 16px;
      &-row {
        margin-bottom: 17px;
        &:first-child {
          margin-bottom: 26px;
          .label {
            font-weight: 700;
          }
        }
      }
      .item {
        min-width: 33.3%;
        margin-right: 5px;
      }
    }
    &-druge {
      padding-top: 24px;

      // margin: {
      //   top: 0.8rem;
      //   bottom: 0.5067rem;
      // }

      border-top: 1px solid #8c8c8c;
      border-bottom: 1px solid #8c8c8c;

      position: relative;
      .access {
        position: absolute;
        width: 100px;
        height: 100px;
        bottom: -30px;
        right: -10px;
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
    &-drug-row {
      &:not(:last-child) {
        margin-bottom: 30px;
      }
      &:last-child {
        margin-bottom: 32px;
      }
      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 700;
        color: #262626;
        line-height: 24px;
      }
      .usage {
        margin-top: 14px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #595959;
        line-height: 16px;
      }
    }
    &-doctor {
      padding-top: 15px;
      &-row {
        // margin-bottom: 0.4533rem;
        margin-bottom: 8px;
        height: 24px;
        &:last-child {
          margin-bottom: 0;
          // margin-top: 0.56rem;
        }
      }
      .item {
        display: flex;
        align-items: center;
        width: 50%;

        .doctor-name {
          width: 83px;
          height: 24px;
        }
      }
      .remark {
        margin-top: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #595959;
        line-height: 24px;
      }
    }
    .label {
      white-space: nowrap;
    }
    .label,
    .content {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #262626;
      line-height: 14px;
    }
    &-hint {
      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 700;
        color: #262626;
        line-height: 24px;
        margin: 24px 0 8px;
      }
      .content {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #595959;
        line-height: 24px;
      }
    }
  }
  .rp {
    margin-bottom: 24px;
    .rp_img {
      width: 32px;
    }
  }
  
  .zy-goods {
    .title {
      font-weight: 500;
      margin-bottom: 8px;
      font-size: 18px;
    }
    .flex-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      width: 100%;
      .flex-item {
        display: inline-flex;
        flex-direction: column;
        color: #262626;
        font: 400 16px/1 PingFang SC;

        &.tcm {
          width: calc(50% - 16px);
          padding-bottom: 20px;
          .tcm-name {
            position: relative;
            padding-right: 6px;
            word-break: break-all;
            .decoction {
              position: absolute;
              font-size: 12px;
              font-style: italic;
              right: -5px;
              top: -13px;
              color: #595959;
            }
          }
        }

        &.tcm-granules {
          width: calc(50% - 8px);
          margin-bottom: 10px;
          font-weight: 500;
          .main {
            .tcm-unit {
              white-space: nowrap;
            }
          }
          .spec {
            font: 400 14px/21px PingFang SC;
            color: #8c8c8c;
          }
        }
      }
    }
    .hide-count-hint {
      color: #eb3223;
    }
  }

  .tcm-usage {
    font: 400 16px/1 PingFang SC;
    color: #262626;
    text-align: left;
    > p {
      text-align: left;
      border: none;
      margin-bottom: 15px;
    }
  }
}
</style>
